import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "../../API/axios";
import BlogCard from "../Blogs/BlogCard";

const BlogsNav = ({ setTab }) => {
  const [blogmenu, setBlogmenu] = useState([]);

  const getblogsmenu = () => {
    axios
      .get(`Blog/GetBlogCategoryDDL`)
      .then((response) => {
        console.log("nav data response", response.data);
        setBlogmenu(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // console.log("isLoading", isLoading);
  useEffect(() => {
    getblogsmenu();
  }, []);

  return (
    <>
      <div className="blog-nav-bar">
        <div className="px-2 px-lg-3 blog-nav-scroll">
          <ul className="p-0 m-0 d-flex align-items-center blog-nav-list">
            <li>
              <NavLink
                to="/blogs"
                end
                onClick={() => setTab("")}
                className={({ isActive }) =>
                  `blog-nav-link ${isActive ? "active-link" : ""}`
                }
              >
                All Blogs
              </NavLink>
            </li>

            {blogmenu != null &&
              blogmenu.map((val) => {
                return (
                  <li key={val.catgryURLvalue}>
                    <NavLink
                      to={"/blogs/category/" + val.catgryURLvalue}
                      className={({ isActive }) =>
                        `blog-nav-link ${isActive ? "active-link" : ""}`
                      }
                      onClick={() => setTab(val.bcatgName)}
                    >
                      {val.bcatgName}
                    </NavLink>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>


    </>
  );
};

export default BlogsNav;
